import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Category, CategoryEditor } from '../../interfaces/interfaces';

@Component({
  selector: 'app-categoryeditor',
  templateUrl: './categoryeditor.component.html',
  styleUrls: ['./categoryeditor.component.scss']
})
export class CategoryeditorComponent implements AfterViewInit {

  categoryId: number|null = null;
  parentCategory: Category|null = null;
  loading = false;

  categoryEditorFormGroup: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    active: new FormControl(false)
  });

  unsubscibe: Subject<void> = new Subject();

  file: File|null = null;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  apiBaseUrl: string = null;

  constructor(
    private apiService: ApiService,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService
  ) {
    this.apiBaseUrl = this.apiService.getApiBaseUrl();
  }

  loadData(): void {
    if (this.categoryId !== null) {
      this.apiService.getCategory(this.categoryId).pipe(takeUntil(this.unsubscibe)).subscribe((rsp) => {
        this.categoryEditorFormGroup.get('name').setValue(rsp.categoryEditor.names[0].name);
        this.categoryEditorFormGroup.get('active').setValue(rsp.categoryEditor.active);
      }).add(() => {
        this.loading = false;
      });
    }
  }

  save(): void {
    if (this.categoryEditorFormGroup.invalid) {
      return;
    }
    this.loading = false;
    const categoryEditor: CategoryEditor = {
      active: this.categoryEditorFormGroup.get('active').value,
      parent: this.parentCategory !== null ? this.parentCategory.id : null,
      names: [{
        languageId: 'hu',
        name: this.categoryEditorFormGroup.get('name').value
      }]
    };
    if (this.categoryId === null) {
      this.apiService.createCategory(categoryEditor, this.file).pipe(takeUntil(this.unsubscibe)).subscribe((rsp) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Kategória létrehozása',
          detail: 'Sikeres létrehozás'
        });
        this.close(true);
      }).add(() => {
        this.loading = false;
      });
    } else {
      this.apiService.updateCategory(this.categoryId, categoryEditor, this.file).pipe(takeUntil(this.unsubscibe)).subscribe((rsp) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Kategória szerkesztése',
          detail: 'Sikeres szerkesztés'
        });
        this.close(true);
      }).add(() => {
        this.loading = false;
      });
    }
  }

  fileUploadInputChanged(files: FileList): void {
    if (files.length > 0) {
      this.file = files.item(0);
    }
  }

  close(result: boolean = false): void {
    this.ref.close(result);
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
    this.categoryId = this.config.data.categoryId;
    this.parentCategory = this.config.data.parentCategory;
    this.loadData();
  }
}
